<pathPantalla></pathPantalla>

<div [hidden]="consulta">
    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}} </h3>
                </header>
            </section>
        </div>
    </div>

    <div class="divisor8"></div>

    <div class="row">

        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                    <dropdownCustom [titulo]="'Periodo de evaluación'" valorName="periodoevaluacionid"
                        displayValor="descripcion" propiedad="periodoevaluacionid"
                        [opciones]="listaperiodoevaluacion" [(ngModel)]="periodoevaluacion"
                        (ngModelChange)="cargardatos($event)"></dropdownCustom>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 bloque caja">
                        <div class="divisor8"></div>
                        <p> Selecciona el departamento o colaborador del que desea visualizar el reporte</p>
                        <div class="divisor8"></div>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-12 card">
                                <div class="col-12" *ngIf="organigrama">
                                    <div class="divisor16" *ngIf="organigrama.length == 0"></div>
                                    <div class="divisor16"></div>
                                    <dx-sortable
                                        filter=".dx-treeview-item"
                                        [allowDropInsideItem]="false"
                                        [allowReordering]="false"
                                        >
                                        <dx-tree-view
                                            id="treeview"
                                            [dataSource]="organigrama"
                                            dataStructure="tree"
                                            (onItemClick)="selectItem($event)"
                                            [searchEnabled]="true"
                                            searchMode="contains"
                                            itemTemplate="itemTemplate"
                                            >
                                            <dxo-search-editor-options placeholder="Buscar"> </dxo-search-editor-options>
                                            <div *dxTemplate="let itemObj of 'itemTemplate'">
                                                <div class="IconoRenglon">
                                                    <div *ngIf="itemObj.tipo == 1">
                                                        <svg-icon
                                                            class="iconoSVG"
                                                            src="./assets/Icono/direccion.svg"
                                                            >
                                                        </svg-icon>
                                                    </div>
                                                    <div *ngIf="itemObj.tipo == 2">
                                                        <svg-icon
                                                            class="iconoSVG"
                                                            src="./assets/Icono/puesto.svg"
                                                            ></svg-icon>
                                                    </div>
                                                    <div *ngIf="itemObj.tipo == 3">
                                                        <svg-icon
                                                            class="iconoSVG"
                                                            src="./assets/Icono/colaborador.svg"
                                                            >
                                                        </svg-icon>
                                                    </div>
                                                    <div class="texto">{{itemObj.text}}</div>
                                                </div>
                                            </div>
                                        </dx-tree-view>
                                    </dx-sortable>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 bloque caja" *ngIf="!infopersona.otropuesto">
                      <div class="row margen" *ngIf="infopersona.colaboradorid">
                          <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                              <h5>{{infopersona.colaborador}}</h5>
                              <div class="divisor8"></div>
                              <h5>{{infopersona.puesto}}</h5>
                          </div>
                          <div class="col-lg-6 col-md-6 col-sm-12 col-12" style="margin-top: 15px;">
                              <div *ngIf="verdetalle">
                                  <button class="boton botonSM filledBlanco" (click)="EvaluacionDetalle()" *ngIf="sistemaService.permisos.consultar"> Ver detalle</button>
                              </div>
                          </div>
                      </div>
                      <div *ngIf="!infopersona.colaboradorid">
                          <h4>{{infopersona.nombre}}</h4>
                      </div>
                      <div *ngFor="let data of info; index as index">
                          <span>{{index + 1}}-{{data.nombrecompetencia}}</span>
                          <div *ngFor="let escala of data.escalaevaluacion; index as index" >
                              <pivotcomponente
                              [info]="escala"
                              >
                              </pivotcomponente>
                          </div>
                          <div *ngIf="data.competenciapreguntaabierta.length > 0">
                            <acordioncomponente [info]="data.competenciapreguntaabierta"></acordioncomponente>

                          </div>
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 bloque caja" *ngIf="infopersona.otropuesto">
                      <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                          <h5>{{infopersona.colaborador}}</h5>
                          <div class="divisor8"></div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-12" style="margin-top: 15px;">
                            <div *ngIf="verdetalle">
                                <button class="boton botonSM filledBlanco" (click)="EvaluacionDetalle()" *ngIf="sistemaService.permisos.consultar"> Ver detalle</button>
                            </div>
                        </div>
                      </div>
                      <div *ngFor="let data of info; index as index">
                        <h5>{{data.datapuesto.puesto}}</h5>
                      <div *ngFor="let dataeval of data.infoevaluacion; index as index">
                          <span>{{index + 1}}-{{dataeval.nombrecompetencia}}</span>
                          <div *ngFor="let escala of dataeval.escalaevaluacion; index as index" >
                              <pivotcomponente
                              [info]="escala"
                              >
                              </pivotcomponente>
                          </div>
                      </div>
                      </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>

<div #evaluaciondetalle></div>
